import styled from "styled-components";
const CalendarDays = styled("div")({
  alignItems: "stretch",
  display: "grid",
  gap: 8,
  gridAutoRows: "24px",
  gridTemplateColumns: "repeat(7, 24px)",
  justifyContent: "center",
  marginBottom: 8
});
const CalendarDay = styled("div")({
  alignItems: "center",
  display: "flex",
  justifyContent: "center"
});
export {
  CalendarDay,
  CalendarDays
};
